import script from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=273fab72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273fab72"]])

export default __exports__